/**
 * Reserve desktop editorial cells beside the preceding product quartet.
 * Count the cards actually loaded, rather than absolute page offsets, so native
 * Horizon append/prepend and filtered section replacement keep their ownership.
 */
class LazyOafCollectionEditorials extends HTMLElement {
  static observedAttributes = ['data-desktop-columns'];

  #observer = new MutationObserver((records) => {
    const grid = this.querySelector('.product-grid');
    if (grid !== this.#grid || records.some((record) => record.target === grid)) {
      this.#layout();
    }
  });

  #grid;

  connectedCallback() {
    this.#layout();
    this.#observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.#observer.disconnect();
  }

  attributeChangedCallback() {
    this.#layout();
  }

  #layout() {
    const grid = this.querySelector('.product-grid');
    this.#grid = grid;
    if (!grid) return;
    if (this.dataset.desktopColumns !== '4') {
      delete grid.dataset.editorialLayout;
      for (const card of grid.querySelectorAll('.lazy-oaf-collection-editorial')) {
        card.style.removeProperty('--editorial-grid-row');
      }
      return;
    }

    let products = 0;
    let editorials = 0;
    const lastRow = { left: -1, right: -1 };

    for (const card of grid.children) {
      if (card.hasAttribute('data-product-id')) {
        products += 1;
      } else if (card.classList.contains('lazy-oaf-collection-editorial')) {
        const side = card.classList.contains('lazy-oaf-collection-editorial--left') ? 'left' : 'right';
        const row = Math.max(1, Math.ceil(products / 4) + editorials, lastRow[side] + 2);
        card.style.setProperty('--editorial-grid-row', String(row));
        lastRow[side] = row;
        editorials += 1;
      }
    }

    grid.dataset.editorialLayout = 'paired';
  }
}

if (!customElements.get('lazy-oaf-collection-editorials')) {
  customElements.define('lazy-oaf-collection-editorials', LazyOafCollectionEditorials);
}
